export default __webpack_public_path__ + "static/media/s4img7.6908aa3a.webp";